const importImages = (r) => r.keys().map(r);
const images = importImages(
  require.context("../../assets/gallery", false, /\.(png)$/)
);

export default images;
